/**
 * Galería de vídeo-tutoriales. Los vídeos no se alojan en el repo:
 * `videos.json` referencia una URL de embed externo (YouTube/Vimeo
 * unlisted, S3/CloudFront…). Sin URL → placeholder "Pendiente".
 */

import { Empty, Typography } from "antd";
import { PageHeader } from "@/components/common/PageHeader";
import { usePageTitle } from "@/hooks";
import { videos } from "@/data/onboarding";
import { VideoEmbed } from "./VideoEmbed";

const { Text } = Typography;

export const VideosPage: React.FC = () => {
  usePageTitle("Vídeo-tutoriales — Onboarding");
  const pending = videos.filter((v) => !v.embedUrl).length;

  return (
    <>
      <PageHeader
        title="Vídeo-tutoriales"
        subtitle="Grabaciones de los procesos clave. La galería está preparada para incorporar más vídeos: se añaden editando videos.json en el repo."
      />
      {pending > 0 ? (
        <Text type="secondary" style={{ display: "block", marginBottom: 16 }}>
          {pending} vídeo{pending === 1 ? "" : "s"} pendiente
          {pending === 1 ? "" : "s"} de subir.
        </Text>
      ) : null}

      {videos.length === 0 ? (
        <Empty description="Aún no hay vídeos catalogados." />
      ) : (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(360px, 1fr))",
            gap: 16,
          }}
        >
          {videos.map((v) => (
            <VideoEmbed key={v.slug} video={v} />
          ))}
        </div>
      )}
    </>
  );
};
